export class ColibriItem {
    constructor({
        codigo,
        tipo,
        marchar = null,
        descricao,
        preco,
        quantidade,
        observacao,
        itens = [],
    }) {
        this.codigo = codigo;
        this.tipo = tipo;
        this.marchar = marchar;
        this.descricao = descricao;
        this.preco = preco;
        this.quantidade = quantidade;
        this.observacao = observacao;
        this.itens = itens;
    }

    static fromOlga(olgaItems = [], configurations) {
        const items = olgaItems.map((item) => {
            if (item?.items?.length > 0) {
                return ColibriItem.fromCombinationItem(item, configurations);
            }
            return ColibriItem.fromCommonItem(item);
        });

        return items.flat(1);
    }

    static fromCommonItem(olgaItem) {
        return [
            new ColibriItem({
                codigo: olgaItem.sizes[0].sku || olgaItem.sku,
                tipo: 'normal',
                itens: null,
                descricao: olgaItem.name,
                observacao: olgaItem?.observation || null,
                quantidade: olgaItem.quantity || 1,
                preco: olgaItem.sizes[0].price || olgaItem.price,
            })
        ];
    }

    static fromCombinationItem(olgaItem, configurations) {
        const questions = olgaItem?.items || [];
        const observations = olgaItem?.observation ? [olgaItem?.observation] : [];

        for (const question of questions) {
            const options = question.items || [];
            const observationOptions = options.filter((o) => !o.sku);

            for (const option of observationOptions) {
                if (option.price > 0) {
                    throw new Error(`O item "${olgaItem.name} - ${option.name}" está sem SKU e com preço`);
                }
                observations.push(option.name);
            }
        }

        const itens = [];
        let slot_index = 0
        for (const question of questions) {
            const options = question.items || [];
            const commonOptions = options.filter((option) => option.sku);

            for (const option of commonOptions) {
                const item = {
                    codigo: option.sku,
                    slot_indice: question.position,
                    quantidade: option.quantity || 1,
                    descricao: option.name,
                    preco: option.price,
                    observacao: null,
                    quantidade: Number(option.quantity || 1) * Number(question.quantity || 1),
                };

                const childrenItems = item?.items || [];
                if (childrenItems.length > 0) {
                    const builtChildrenItems = ColibriItem.processRecursiveItems(childrenItems, item.quantity || 1);
                    itens.push(...builtChildrenItems)
                }
            }
        }

        if (itens.length === 0) {
            const builtItem = new ColibriItem({
                codigo: olgaItem.sizes[0].sku || olgaItem.sku,
                tipo: 'normal',
                itens: null,
                descricao: olgaItem.name,
                observacao: observations?.length > 0 ? observations : null,
                quantidade: olgaItem.quantity || 1,
                preco: olgaItem.sizes[0].price || olgaItem.price,
            });

            return [builtItem];
        }

        const allowExplodeCombination = !!configurations.allowExplodeCombination;
        if (allowExplodeCombination) {
           const builtMainItem = new ColibriItem({
                codigo: olgaItem.sizes[0].sku || olgaItem.sku,
                tipo: 'normal',
                itens: null,
                descricao: olgaItem.name,
                observacao: observations?.length > 0 ? observations : null,
                quantidade: olgaItem.quantity || 1,
                preco: olgaItem.sizes[0].price || olgaItem.price,
            });

            const builtItems = [builtMainItem];

            itens.forEach((item) => {
                const builtItem = new ColibriItem({
                    codigo: item.codigo,
                    tipo: 'normal',
                    itens: null,
                    descricao: item.descricao,
                    observacao: null,
                    quantidade: Number(item.quantidade) * Number(builtMainItem.quantidade),
                    preco: item.preco,
                });
                builtItems.push(builtItem);
            });

            return builtItems;
        }

        const builtItem = new ColibriItem({
            codigo: olgaItem.sizes[0].sku || olgaItem.sku,
            tipo: 'combo',
            itens: itens,
            descricao: olgaItem.name,
            observacao: observations?.length > 0 ? observations : null,
            quantidade: olgaItem.quantity || 1,
            preco: olgaItem.sizes[0].price || olgaItem.price,
        });

        return [builtItem];
    }

    static processRecursiveItems(items, parentQuantity = 1) {
        const result = [];
        
        for (const item of items) {
            if (item.sku) {
                result.push({
                    codigo: item.sku,
                    slot_indice: null, 
                    quantidade: (item.quantity || 1) * parentQuantity,
                    descricao: item.name,
                    preco: item.price,
                    observacao: null,
                });
            }
            

            if (item.items && item.items.length > 0) {
                const subItems = ColibriItem.processRecursiveItems(item.items, (item.quantity || 1) * parentQuantity);
                result.push(...subItems);
            }
        }
        
        return result;
    }
}
